<div class="">
    <div class="row">
        <div class="col-xs-12">
            <h2 translate>
                Search Patients
            </h2>
        </div>
    </div>
    <form [formGroup]="searchFormGroup" (ngSubmit)="search()" #form="ngForm">
        <ap-alert></ap-alert>
        <div class="row">
            <div class="col-xs-12 col-md-6 panel-row-bottom">
                <div class="form-group">
                    <label for="lName" class="active" translate>Last Name</label>
                    <input id="lName" class="form-control"
                        [ngClass]="{'error': lastNameControl.invalid && form.submitted}" type="text"
                        formControlName="lastNameControl" />
                </div>
            </div>
            <div class="col-xs-12 col-md-6 panel-row-bottom">
                <div class="form-group">
                    <label for="fName" class="active" translate>First Name</label>
                    <input id="fName" class="form-control"
                        [ngClass]="{'error': firstNameControl.invalid && form.submitted}" type="text"
                        formControlName="firstNameControl" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-6 panel-row-bottom">
                <div class="form-group">
                    <label class="active" for="phoneNum" translate>Phone</label>
                    <input id="phoneNum" placeholder="(xxx)xxx-xxxx" class="form-control"
                        [ngClass]="{'error': phoneNumberControl.invalid && form.submitted}" type="text"
                        formControlName="phoneNumberControl" />
                </div>
            </div>
            <div class="col-xs-6 panel-row-bottom">
                <div class="form-group">
                    <label class="active" for="ssn" translate>SSN</label>
                    <input id="ssn" placeholder="xxx-xx-xxxx" class="form-control"
                        [ngClass]="{'error': ssnControl.invalid && form.submitted}" type="text"
                        formControlName="ssnControl">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-6 panel-row-bottom">
                <div class="form-group">
                    <label class="active" for="externalId" translate>External ID</label>
                    <input id="externalId" class="form-control"
                        [ngClass]="{'error': externalIdControl.invalid && form.submitted}" type="text"
                        formControlName="externalIdControl">
                </div>
            </div>
            <div class="col-xs-6 panel-row-bottom">
                <div class="form-group">
                    <label class="active" for="search-dob" translate>DOB</label>
                    <ap-date-picker
                      [baseId]="'search-date-of-birth'"
                      [required]="false"
                      [formGroupSubmitted]="form.submitted"
                      [formGroup]="searchFormGroup"
                      [controlName]="'dateOfBirthControl'"
                      formControlName="dateOfBirthControl"
                      [labelName]="'DOB'"
                      [showLabel]="false"
                      (ngModelChange)="onDateOfBirthChanged($event)">
                  </ap-date-picker>
                </div>
            </div>
        </div>
        <div class="row">
            <!-- Service Site -->
        <div class="col-xs-6">
            <div class="form-group">
              <label class="active">{{'Service Site' | translate}}</label>
              <ap-findcontrol [baseId]="'search-service-site'"
                              [findControlId]="findControlIdService.FacilityServiceSite"
                              [(selectedPk)]="selectedServiceSiteId"
                              [placeHolder]=""
                              [singleSelect]="true"
                              >
              </ap-findcontrol>
            </div>
          </div>

          <!-- Program -->
          <div class="col-xs-6">
            <div class="form-group">
              <label class="active">{{'Program' | translate}}</label>
              <ap-findcontrol [baseId]="'search-patient-program'"
                              [findControlId]="findControlIdService.FacilityPatientProgram"
                              [(selectedPks)]="selectedPatientProgramIds"
                              [placeHolder]=""
                              [singleSelect]="false">
              </ap-findcontrol>
            </div>
          </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-6">
                <div class="form-group">
                    <label class="active" for="fromdate" translate>With visit notes from</label>
                    <ap-date-picker
                      [baseId]="'search-date-from'"
                      [required]="false"
                      [formGroupSubmitted]="form.submitted"
                      [formGroup]="searchFormGroup"
                      [controlName]="'fromDateControl'"
                      formControlName="fromDateControl"
                      [labelName]="'From date'"
                      [showLabel]="false"
                      [maxDate]="selectedToDate"
                      (ngModelChange)="onFromDateChanged($event)">
                  </ap-date-picker>
                </div>
            </div>
            <div class="col-xs-12 col-md-6">
                <div class="form-group">
                    <label class="active" for="todate" translate>To</label>
                    <ap-date-picker
                      [baseId]="'search-date-to'"
                      [required]="false"
                      [formGroupSubmitted]="form.submitted"
                      [formGroup]="searchFormGroup"
                      [controlName]="'toDateControl'"
                      formControlName="toDateControl"
                      [labelName]="'To date'"
                      [showLabel]="false"
                      [minDate]="selectedFromDate"
                      (ngModelChange)="onToDateChanged($event)">
                  </ap-date-picker>
                </div>
            </div>
        </div>
        <p></p>
        <div class="row">
            <div class="col-xs-12">
                <button type="button" (click)="clear()" class="btn btn-secondary pull-right btn-flush-right" translate>
                    Clear
                </button>
                <button id="searchSearchButton" type="submit" [disabled]="dataLoading"
                    class="btn btn-primary pull-right" translate>
                    Search
                </button>
            </div>
        </div>
    </form>
    <hr>
    <div class="row">
        <div class="col-xs-12">
            <h2 translate>
                Results
            </h2>
        </div>
    </div>
    <div class="text-center" *ngIf="dataLoading">
        <ap-spinner size="3"></ap-spinner>
    </div>
    <div class="search-results" *ngIf="!dataLoading">
        <table id="example" class="table emds-table table-sticky-header table-striped table-border-top table-flush-top"
            cellspacing="0" width="100%">
            <thead>
                <tr>
                    <th translate>ID</th>
                    <th translate>Name</th>
                    <th translate>DOB</th>
                    <th translate>Practice Provider</th>
                    <th translate>Most Recent Visit Date</th>
                    <th *ngIf="isActiveDirectoryUser || showServiceSiteColumn" translate>Service Site</th>
                    <th *ngIf="isActiveDirectoryUser || showProgramColumn" translate>Program</th>
                    <th></th>
                    <th></th>
                    <th *ngIf="showATSAction"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let result of searchResults">
                    <td>{{result.ExternalId}}</td>
                    <td>
                      <span>{{result.FirstName}} {{result.LastName}}</span>
                    </td>
                    <td>{{result.BirthDate | date: 'M/d/yyyy'}}</td>
                    <td>{{result.PracticeProvider}}</td>
                    <td>{{result.VisitDate | date: 'M/d/yyyy'}}
                        <span *ngIf="!result.IsCompletedVisit" translate> (Incomplete Visit)</span>
                    </td>
                    <td *ngIf="isActiveDirectoryUser || showServiceSiteColumn">{{result.ServiceSite?.Name}}</td>
                    <td *ngIf="isActiveDirectoryUser || showProgramColumn">
                        <span *ngFor="let program of result.PatientPrograms; first as isFirst">
                            <span *ngIf="!isFirst">, </span>
                            {{program.Name}}
                        </span>
                    </td>

                    <td class="td-icon-center">
                        <a *ngIf="!result.Downloaded" apSaveToFile
                            [documentDownload]="downloadVisitRef.bind(undefined, result)">
                            <span [hidden]="result.Downloading" translate>Download</span>
                            <ap-spinner [hidden]="!result.Downloading"></ap-spinner>
                        </a>
                        <i *ngIf="!result.Downloading && result.Downloaded" class="material-icons">done</i>
                    </td>
                    <td>
                        <a (click)="display(result)"><span translate>View</span></a>
                    </td>
                    <td *ngIf="showATSAction">
                      <a (click)="openATS(result)"><span translate>Attestation</span></a>
                    </td>
                </tr>
            </tbody>
        </table>
        <div [hidden]="searchResults?.length || dataLoading" translate>
            No Matches Found
        </div>
    </div>
</div>
